import { render, staticRenderFns } from "./IncidentsModal.vue?vue&type=template&id=98f27a98&"
import script from "./IncidentsModal.vue?vue&type=script&lang=ts&"
export * from "./IncidentsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports